import { Component, Inject, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { TranslateService } from '@ngx-translate/core';
import { IdexService } from 'app/idex.service';
import { Toast } from 'app/shared/toast/toast';
import { ConfirmDeleteComponent } from '../confirm-delete/confirm-delete.component';
import { UploadCertificateComponent } from '../upload-certificate/upload-certificate.component';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
   selector: 'app-personal-certificate',
   templateUrl: './personal-certificate.component.html',
   styleUrls: ['./personal-certificate.component.css']
})
export class PersonalCertificateComponent implements OnInit {

   defaultValue: string;
   userCert: any = [];
   certs: any = [];
   certDefaultId: string;
   myControlCertificate = new FormControl<string | Certificate>('');
   filteredOptions: Observable<Certificate[]>;
   @ViewChild('certList', { static: false }) certList: ElementRef;

   constructor(@Inject(MAT_DIALOG_DATA) private data: any, public service: IdexService,
      private dialogRef: MatDialogRef<PersonalCertificateComponent>, private dialog: MatDialog
      , private toast: Toast, private translate: TranslateService) {
   }

   ngOnInit(): void {
      this.loadData();
      this.loadDdlData();
      this.filteredOptions = this.myControlCertificate.valueChanges.pipe(
         startWith(''),
         map(value => {
            console.log(value);
            const certName = typeof value === 'string' ? value : value?.certName;
            return certName ? this._filter(certName as string) : this.userCert.slice();
         }),
      );
   }

   loadData(): void { 
      this.service.get('cert/list/PSN').subscribe(data => {
        // Check if 'data' is not null
        if (data) {
            if (data.length > 0) {
               this.certList.nativeElement.value = data[0].certName;
            }
         }
      });
   }
    
   loadDdlData(): void {
      this.service.get('cert/list')
      .subscribe(data => {
         if (data) {
            this.userCert = data;
            this.loadCertDefault();
         }
      });
   }

   loadCertDefault(): void {
      this.service.get('cert/default')
      .subscribe(data => {
         if (data) {
            this.defaultValue = data;
         }
      });
   }

   save(): void {
      this.certDefaultId = (<HTMLInputElement>document.getElementById("certDefaultId")).value;
      const obj = {
         id: this.certDefaultId
      };
         this.service.post('cert/save', obj)
         .subscribe(data => {
            if (data) {
               this.defaultValue = data.id;
               this.onAlert('alert.save_complete');
               this.dialogRef.close();
               this.dialog.closeAll();
            }
         });
   }

   openUploadCert(): void {
      const dialogRef = this.dialog.open(UploadCertificateComponent, {
         disableClose: true,
         data: {
            'type': 'PSN',
            'tin': '',
            'id': ''
         }
      });

      dialogRef.afterClosed().subscribe(result => {
         this.loadData();
         this.loadDdlData();
      });
   }

   openUpdateCert(data: any): void {
      const dialogRef = this.dialog.open(UploadCertificateComponent, {
         disableClose: true,
         data: {
            'type': 'PSN',
            'tin': '',
            'id': data.id
         }
      });
      dialogRef.afterClosed().subscribe(result => {
         this.loadData();
      });
   }

   delete(data: any): void {
      const dialogRef = this.dialog.open(ConfirmDeleteComponent, {
         disableClose: true,
         data: {
            item: {
               'id': data.id,
            },
            'service': this.service,
            'name': data.certName
         }
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            this.service.delete(`cert/${data.id}`).subscribe(obj => {
               this.onAlert('alert.confirm_delete');
               this.dialogRef.close(true);
            });
         }
      });
   }

   onAlert(text: string) {
      this.translate.get(text).subscribe(s => {
         this.toast.success(s);
      });
   }

   displayFn(certificate: Certificate): string {
      return certificate && certificate.certName ? certificate.certName : '';
   }

   private _filter(certName: string): Certificate[] {
      const filterValue = certName.toLowerCase();
      return this.userCert.filter(userCert => userCert.certName.toLowerCase().includes(filterValue));
   }
}

export interface Certificate {
   certName: string
   objectName: string;
   id: string;
}
